module.exports = "<div [style.padding.px]=\"12\" [innerHtml]=\"termsOfService\"></div>\n"